<template>
    <section class="newsevents-section">
        <div class="filter-section"
            v-if="themes && themes.length > 0 || years && years.length > 0 || provinces && provinces.length > 0 || types && types.length > 0">
            <div class="filter-items">
                <div class="filter-item filter-item--mw" v-if="themes && themes.length > 0">
                    <select @change="filterChanged" :disabled="isLoading" v-model="theme" class="filter-item__select">
                        <option value="All">{{ dictionaries.newsEventsThemeOptionDefault }}</option>
                        <option :value="theme.key" v-for="(theme, index) in themes" v-if="theme.name">{{ theme.name }}
                        </option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw" v-if="types && types.length > 0">
                    <select @change="filterChanged" :disabled="isLoading" v-model="type" class="filter-item__select">
                        <option value="All">{{ dictionaries.newsEventsTypeOptionDefault }}</option>
                        <option :value="type.key" v-for="(type, index) in types" v-if="type.name">{{ type.name }}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw" v-if="years && years.length > 0">
                    <select @change="filterChanged" :disabled="isLoading" v-model="year" class="filter-item__select">
                        <option value="All">{{ dictionaries.newsEventsYearOptionDefault }}</option>
                        <option :value="year.key" v-for="(year, index) in years" v-if="year.name">{{ year.name }}</option>
                    </select>
                </div>
                <div class="filter-item filter-item--mw" v-if="provinces && provinces.length > 0">
                    <select @change="filterChanged" :disabled="isLoading" v-model="province"
                        class="filter-item__select">
                        <option value="All">{{ dictionaries.newsEventsProvinceOptionDefault }}</option>
                        <option :value="province.key" v-for="(province, index) in provinces" v-if="province.name">
                            {{ province.name }}</option>
                    </select>
                </div>
                <div class="filter-item">
                    <button type="button" class="filter-item__button" @click="resetFilter"
                        :disabled="isLoading">{{ dictionaries.newsEventsFilterReset }}</button>
                </div>
            </div>
        </div>
        <div class="newsevents-items" v-show="items.length">
            <newsEventItem v-for="newsEventItem in items" :newsEventItem="newsEventItem" :key="newsEventItem.id">
            </newsEventItem>
        </div>
        <div class="newsevents-items__no-result" v-show="!items.length && !isLoading">
            {{ dictionaries.newsEventsNoResult }}</div>
        <div class="newsevents-items__cta" v-show="hasMoreProductsToLoad">
            <a @click="getNextPage" :disabled="isLoading"
                class="newsevents-items__load-more">{{ dictionaries.newsEventsLoadMore }}</a>
        </div>
    </section>
</template>

<script>
import NewsEventItem from "./components/newsEventItem.vue";
import { bindRoute } from "./mixins/bindroute.js";

const serviceUrl = "/umbraco/api/NewsEvents/GetNewsEventsListPage",
    defaultPage = 1,
    defaultTheme = "All",
    defaultYear = "All",
    defaultProvince = "All",
    defaultType = "All";

export default {
    name: "newsEvents",
    components: {
        NewsEventItem
    },
    data() {
        return {
            dictionaries: [],
            themes: [],
            years: [],
            provinces: [],
            types: [],
            items: [],
            pageSize: 9,
            totalItems: 0,
            isLoading: false
        };
    },
    created() {
        this.pageId = this.$parent.pageId;
        this.getInitialProducts();
    },
    mixins: [
        bindRoute({
            page: defaultPage,
            theme: defaultTheme,
            year: defaultYear,
            province: defaultProvince,
            type: defaultType,
        })
    ],
    methods: {
        getItems(amountToSkip, pageSize) {
            var vm = this,
                languageCode = $("html").attr("lang");
            vm.toggleSpinner(true);
            var object = {
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize
            };
            if (this.theme != defaultTheme) {
                object.theme = this.theme;
            }
            if (this.year != defaultYear) {
                object.year = this.year;
            }
            if (this.type != defaultType) {
                object.type = this.type;
            }
            if (this.province != defaultProvince) {
                object.province = this.province;
            }
            if (this.pageId) {
                object.pageId = this.pageId;
            }
            $.get(serviceUrl, object, function (response) {
                vm.dictionaries = response.dictionaries;
                vm.themes = response.facets.themes;
                vm.years = response.facets.years;
                vm.types = response.facets.types;
                vm.provinces = response.facets.provinces;
                vm.items.push(...response.items);
                vm.totalItems = response.totalItems;
            }).fail(function (error) {
                console.log(error);
            }).always(function () {
                vm.toggleSpinner(false);
            });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getItems(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialProducts() {
            // Get all products up to, and including, the current page
            const initialPageSize = this.pageSize * this.page;
            this.getItems(0, initialPageSize);
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            if (isLoading) {
                $("body").addClass("is-loading");
            } else {
                $("body").removeClass("is-loading");
            }
        },
        filterChanged() {
            this.items = [];
            this.totalItems = 0;
            this.page = defaultPage;
            this.getItems(0, this.pageSize);
        },
        resetFilter() {
            this.items = [];
            this.totalItems = 0;
            this.page = defaultPage;
            this.theme = defaultTheme;
            this.year = defaultYear;
            this.type = defaultType;
            this.province = defaultProvince;
            this.getItems(0, this.pageSize);
        }
    },
    computed: {
        hasMoreProductsToLoad() {
            return this.totalItems !== 0 && this.items.length < this.totalItems;
        }
    }
};
</script>